/**
 * Style Shop login button inner button (inside shadow DOM): full width, no margin, match cart button radius.
 * Runs in cart page and when cart drawer/content is present.
 */
function styleShopLoginButtonShadow() {
  var containers = document.querySelectorAll('.cart__checkout-wrapper shop-login-button, .cart__dynamic-checkout-blocks shop-login-button, .additional-checkout-buttons shop-login-button, .cart-drawer shop-login-button');
  var radius = getComputedStyle(document.documentElement).getPropertyValue('--button-radius') || '4px';
  radius = radius.trim() || '4px';
  containers.forEach(function (host) {
    if (!host.shadowRoot) return;
    var btn = host.shadowRoot.querySelector('button');
    if (!btn) return;
    btn.style.setProperty('width', '100%', 'important');
    btn.style.setProperty('min-width', '100%', 'important');
    btn.style.setProperty('margin', '0', 'important');
    btn.style.setProperty('box-sizing', 'border-box', 'important');
    btn.style.setProperty('border-radius', radius, 'important');
  });
}

$(function () {
  (function jscSetHeaderSectionHeightCssVar() {
    var root = document.documentElement;
    function measureAndSet() {
      var total = 0;
      var toolbarEl = document.querySelector('.toolbar-section');
      if (toolbarEl) {
        total += Math.round(toolbarEl.getBoundingClientRect().height);
      }
      var headerEl =
        document.querySelector('header-section') || document.querySelector('.header-section');
      if (headerEl) {
        total += Math.round(headerEl.getBoundingClientRect().height);
      }
      if (total < 1) {
        return;
      }
      root.style.setProperty('--header-section-height', total + 'px');
    }
    measureAndSet();
    document.addEventListener('headerStickyChange', measureAndSet);
    window.addEventListener('resize', function () {
      if (window.__jscHeaderSectionHTimeout) {
        clearTimeout(window.__jscHeaderSectionHTimeout);
      }
      window.__jscHeaderSectionHTimeout = setTimeout(measureAndSet, 150);
    });
    var headerEl =
      document.querySelector('header-section') || document.querySelector('.header-section');
    var toolbarEl = document.querySelector('.toolbar-section');
    if (typeof ResizeObserver !== 'undefined') {
      var ro = new ResizeObserver(measureAndSet);
      if (headerEl) {
        ro.observe(headerEl);
      }
      if (toolbarEl) {
        ro.observe(toolbarEl);
      }
    }
  })();

  shippingTypeInject();
  setTimeout(function(){
    shippingType();
  },900);

  styleShopLoginButtonShadow();
  setTimeout(styleShopLoginButtonShadow, 500);
  setTimeout(styleShopLoginButtonShadow, 1500);
  var cartContainers = document.querySelectorAll('.cart__checkout-wrapper, .cart__dynamic-checkout-blocks, .cart-drawer, .additional-checkout-buttons');
  if (cartContainers.length && typeof MutationObserver !== 'undefined') {
    var cartMo = new MutationObserver(function () {
      styleShopLoginButtonShadow();
    });
    cartContainers.forEach(function (node) {
      cartMo.observe(node, { childList: true, subtree: true });
    });
  }
  onVariantChange();
  any_label_exist();
  onloadWishlist();
  removeCartAuthority();
  onloadScrollToSection();
  onLoadCookieBar();
  onloadPrdImageForCombinedListingPrd();
  if (typeof window.setAvailabilityMenuOpen === 'function') {
    window.setAvailabilityMenuOpen(true);
  }
  // Titles first so vendor/price line up, then meta/vendor equalize
  equalizeFeatureCollectionGridProductTitleHeights();
  equalizeFeatureCollectionGridProductVendorHeights();
  equalizeFeatureCollectionGridMetaHeights();
  equalizeCartPageGridMetaHeights();
  equalizeCartPageGridProductTitleHeights();
  equalizeCartPageGridProductVendorHeights();
  equalizeCartDrawerGridMetaHeights();
  equalizeCartDrawerGridProductTitleHeights();
  equalizeCartDrawerGridProductVendorHeights();

  // Re-run after layout/fonts/is-land paint — title equalize depends on final wrapping
  function jscScheduleTitleEqualize() {
    requestAnimationFrame(function () {
      equalizeFeatureCollectionGridProductTitleHeights();
      equalizeFeatureCollectionGridProductVendorHeights();
      equalizeFeatureCollectionGridMetaHeights();
    });
  }
  [100, 400, 1000, 2000].forEach(function (ms) {
    setTimeout(jscScheduleTitleEqualize, ms);
  });
  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(jscScheduleTitleEqualize);
  }
  window.addEventListener('load', jscScheduleTitleEqualize);

  // Featured collection / grids may hydrate late (is-land)
  if (typeof MutationObserver !== 'undefined') {
    var titleEqualizeMo = new MutationObserver(function () {
      clearTimeout(window.__jscTitleEqualizeMoTimer);
      window.__jscTitleEqualizeMoTimer = setTimeout(jscScheduleTitleEqualize, 200);
    });
    document.querySelectorAll('.jsc-featured-collection, .new-grid.product-grid, .featured-collection__carousel-grid-items').forEach(function (node) {
      titleEqualizeMo.observe(node, { childList: true, subtree: true, characterData: true });
    });
  }

 $(".mz-thumb").click(function () {
   var only_variant = $(this).attr("data-image");
   //console.log(only_variant);
   $("figure.mz-figure>img").attr("src",only_variant) ;
 });

  $('.jsc-order-note').on('change', function() {
    var noteValue = $(this).val();
    $('#hidden_order_note').val(noteValue);
    console.log('Order Note value:', noteValue); // Debugging the value
  });
  
  var additional_images = []
  var current_thumb = 0;
  
  $(".jsc-blog-right").click(function () {
    console.log('right')
    var modalImg = document.getElementById("img01");
    if ( current_thumb >= (additional_images.length - 1)) {
      current_thumb = 0;
    }
    else {
          current_thumb += 1;
    }

    var img = additional_images[(current_thumb )];
    console.log(img)
      modalImg.src = img;

  })
    $(".jsc-blog-left").click(function () {
    console.log('left')
    var modalImg = document.getElementById("img01");
    if ( current_thumb == 0) {
      current_thumb = additional_images.length-1;
    }
    else {
          current_thumb -= 1;
    }

    var img = additional_images[(current_thumb )];
    console.log(img)
      modalImg.src = img;

  })
  window.addEventListener("resize", function () {
    if (window.innerWidth <= 768) {
      $(".fancybox-close").click();
    }
  });

  if ($(".jsc_order_refund").length) {
    console.log("here")
    var $path = $(".jsc_order_refund");
    var customer_email = $path.attr("data-email");
    var order_name = $path.attr("data-id");
    var query_name = order_name;
    if (order_name.includes("#")) {
      query_name = order_name.replace(/#/g, "%23");
    }

    var order_url =
      "/admin/api/2021-10/orders/"+ order_name + ".json"
    console.log(order_url)
    jQuery
      .ajax({
        type: "GET",
        url: order_url,
        error: function (e) {
          console.log(e);
        },
        success: function (result) {
          console.log("result", result);
          var data = result.order
          console.log('data',data)
          if (data.id== order_name) {
            console.log('hihi')
              for (var refund in data.refunds) {
                var refunded_object = data.refunds[refund];
                var refundid =
                  refunded_object.refund_line_items[0].line_item_id;
                console.log(refunded_object.refund_line_items.length);
                if (refunded_object.refund_line_items.length == 1) {
                  if (refunded_object.transactions.length) {
                    console.log("refund exists");
                    var refundamount = refunded_object.transactions[0].amount;
                    var id = "#" + refundid;
                    var price = "-" + "<span>&#36;</span>" + refundamount;
                    console.log(id);
                    $(id).find('.jsc-specific-refund').html(price);
                  }
                }
              }
          }
        }
      })
      .done(function () {
        console.log("done");
      });
  }
});
// shippingTypeInject = () =>{
//   setTimeout(function(){
//     console.log("here123");
//     $(".checkoutMethodsContainer.inline").attr('onclick', 'shippingType()');
//   }, 900);
// }

shippingTypeInject = () => {
  const interval = setInterval(() => {
    if ($(".checkoutMethodsContainer.inline").length) {
      $(".checkoutMethodsContainer.inline").attr('onclick', 'shippingType()');
      clearInterval(interval); // Stop the interval once the element is found and modified
    }
  }, 1000);
}

shippingType = () =>{
  var $input = $('.checkoutMethodsContainer.inline input[type="radio"]:checked').val();
  var $method = $('.checkoutMethodsContainer.inline input[type="radio"]:checked').closest('label').find('span').text();
  console.log("input", $input);
  console.log("method", $method);
  if ($method == 'Self-Collect' || $input == 'pickup') {
    $('.jsc-cart__checkout-validate').removeAttr('onclick');
    $('.jsc-cart__checkout-validate').attr('onclick', 'selfCollCheckout(this)');
    // $('.jsc-authority-content').hide();
    $('#authority_to_leave').val('');
    $('.jsc-authority-select-text').text('PLEASE SELECT THE AUTHORITY TO LEAVE OPTIONS');
    $('.jsc-authority-select-option').find('span.is-selected').removeClass('is-selected');
    $('.jsc-authority-disclamer').hide();
    $('.jsc-cart-note').hide();
  } else {
    $('.jsc-cart__checkout-validate').removeAttr('onclick');
    $('.jsc-cart__checkout-validate').attr('onclick', 'validate_option(this)');
    // $('.jsc-authority-content').show();
    $('.jsc-cart-note').show();
  }
}


setCookies = (cname,cval,days) =>{
  const d = new Date();
  d.setTime(d.getTime() + (days*24*60*60*1000));

  let expires = "expires=" + d.toUTCString();
  document.cookie = cname + "=" + cval + ";" + expires + ";path=/";
}

getCookies = (cname) =>{
  let name = cname + "=";
  let decodedCookie = decodeURIComponent(document.cookie);
  let ca = decodedCookie.split(';');
  for(let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

acceptCookies = (e) =>{
  var $this = $(e);

  $this.parents('.jsc-cookies-container').hide();

  setCookies('jsc-accept-cookie', true, 120);
}

onLoadCookieBar = () =>{  
  var isAccpet = getCookies('jsc-accept-cookie') === 'true';
  if (isAccpet) {
    $('.jsc-cookies-container').hide();
  }
  else {
    $('.jsc-cookies-container').removeClass('d-none');
  }
}

selfCollCheckout = () =>{
  $('#checkout_btn').click();
}
function changeImg(evt) {
  var img = $(evt).attr("data-src");
  //console.log(img);
  var url = "url(" +img +")";
  $(evt)
    .parents(".qv-images-section")
    .find(".qv-images")
    .css({ "background-image": url });

};

function buildImage(imageInfo, size, className) {
  if (!imageInfo) {
    imageInfo = {
      src: boostPFSConfig.general.no_image_url,
      width: 480,
      height: 480,
      aspect_ratio: 1,
    };
  }

  var width = size.split("x")[0];
  var height = 0;
  if (!imageInfo && imageInfo.aspect_ratio) {
    height = width * imageInfo.aspect_ratio;
  } else {
    height = 512;
  }
  var srcset =
    "data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='X' height='Y'></svg>";
  srcset = srcset.replace("X", width).replace("Y", height).replace(/ /g, "%20");

  var html =
    "<img " +ß
    'src="' +
    Utils.optimizeImage(imageInfo.src, size) +
    '" ' +
    'class="' +
    className +
    '" ' +
    'alt="{{itemTitle}}" ' +
    'data-rimg="lazy" ' +
    'data-rimg-scale="1" ' +
    'data-rimg-template="' +
    Utils.optimizeImage(imageInfo.src, "{size}") +
    '" ' +
    'data-rimg-max="' +
    imageInfo.width +
    "x" +
    imageInfo.height +
    '" ' +
    "data-rimg-crop " +
    ">";

  html += "<div data-rimg-canvas></div>";
  return html;
}


function parseItem(el) {
  var options =
    arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var isImage = el.hasAttribute("data-rimg-template");

  /**
   * @typedef {Settings} Item
   */
  return {
    el: el,

    // Type of element
    isImage: isImage,
    isBackgroundImage: isImage && el.tagName !== "IMG",

    // Image scale
    scale: getData(el, "scale", options),

    // Device density
    density: window.devicePixelRatio || 1,

    // Image template URL
    template: getData(el, "template", options),
    templateRender: options.templateRender || defaults.templateRender,

    // Maximum image dimensions
    max: getData(el, "max", options, parseSize),

    // Round image dimensions to the nearest multiple
    round: getData(el, "round", options),

    // Placeholder image dimensions
    placeholder: getData(el, "placeholder", options, parseSize),

    // Crop value; null if image is uncropped, otherwise equal to the Shopify crop parameter ('center', 'top', etc.)
    crop: getData(el, "crop", options, processCropValue),
  };
}

/**
 * Round to the nearest multiple.
 *
 * This is so we don't tax the image server too much.
 *
 * @param {Number} size The size, in pixels.
 * @param {Number} [multiple] The multiple to round to the nearest.
 * @param {Number} [maxLimit] Maximum allowed value - value to return if rounded multiple is above this limit
 * @returns {Number}
 */
function roundSize(size) {
  var multiple =
    arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 32;
  var maxLimit =
    arguments.length > 2 && arguments[2] !== undefined
      ? arguments[2]
      : Infinity;

  return size === 0
    ? multiple
    : Math.min(Math.ceil(size / multiple) * multiple, maxLimit);
}

/**
 * Get the size of an element.
 *
 * If it is too small, it's parent element is checked, and so on. This helps
 * avoid the situation where an element doesn't have a size yet or is positioned
 * out of the layout.
 *
 * @param {HTMLElement} el
 * @return {Object} size
 * @return {Number} size.width The width, in pixels.
 * @return {Number} size.height The height, in pixels.
 */
function getElementSize(el) {
  var size = { width: 0, height: 0 };

  while (el) {
    size.width = el.offsetWidth;
    size.height = el.offsetHeight;
    if (size.width > 20 && size.height > 20) break;
    el = el.parentNode;
  }

  return size;
}

/**
 * Trigger a custom event.
 *
 * Note: this approach is deprecated, but still required to support older
 * browsers such as IE 10.
 *
 * @see https://developer.mozilla.org/en-US/docs/Web/Guide/Events/Creating_and_triggering_events
 *
 * @param {HTMLElement} el
 *        The element to trigger the event on.
 *
 * @param {String} name
 *        The event name.
 *
 * @returns {Boolean}
 *          True if the event was canceled.
 */
function trigger(el, name) {
  var event = document.createEvent("Event");
  event.initEvent(name, true, true);
  return !el.dispatchEvent(event);
}

/**
 * Return the maximum supported density of the image, given the container.
 *
 * @param {Item} item
 * @param {Size} size
 */
function supportedDensity(item, size) {
  return Math.min(
    Math.min(Math.max(item.max.width / size.width, 1), item.density),
    Math.min(Math.max(item.max.height / size.height, 1), item.density)
  ).toFixed(2);
}

/**
 * Set the image URL on the element. Supports background images and `srcset`.
 *
 * @param {Item} item
 * @param {Size} size
 * @param {Boolean} isPlaceholder
 */
function setImage(item, size, isPlaceholder, onLoad) {
  var render = item.templateRender;
  var density = isPlaceholder ? 1 : supportedDensity(item, size);
  var round = isPlaceholder ? 1 : item.round;

  // Calculate the final display size, taking into account the image's
  // maximum dimensions.
  var targetWidth = size.width * density;
  var targetHeight = size.height * density;

  var displaySize = void 0;

  if (item.crop) {
    displaySize = {
      width: roundSize(targetWidth, round, item.max.width),
      height: roundSize(targetHeight, round, item.max.height),
    };
  } else {
    // Shopify serves images clamped by the requested dimensions (fitted to the smallest dimension).
    // To get the desired and expected pixel density we need to request cover dimensions (fitted to largest dimension).
    // This isn't a problem with cropped images which are served at the exact dimension requested.
    var containerAspectRatio = size.width / size.height;
    var imageAspectRatio = item.max.width / item.max.height;

    if (containerAspectRatio > imageAspectRatio) {
      // fit width
      displaySize = {
        width: roundSize(targetWidth, round, item.max.width),
        height: roundSize(
          targetWidth / imageAspectRatio,
          round,
          item.max.height
        ),
      };
    } else {
      // fit height
      displaySize = {
        width: roundSize(
          targetHeight * imageAspectRatio,
          round,
          item.max.width
        ),
        height: roundSize(targetHeight, round, item.max.height),
      };
    }
  }

  var url = render(item.template, displaySize);

  // On load callback
  var image = new Image();
  image.onload = onLoad;
  image.src = url;

  // Set image
  if (item.isBackgroundImage) {
    item.el.style.backgroundImage = "url('" + url + "')";
  } else {
    item.el.setAttribute("srcset", url + " " + density + "x");
  }
}

/**
 * Load the image, set loaded status, and trigger the load event.
 *
 * @fires rimg:load
 * @fires rimg:error
 * @param {Item} item
 * @param {Size} size
 */
function loadFullImage(item, size) {
  var el = item.el;

  setImage(item, size, false, function (event) {
    if (event.type === "load") {
      el.setAttribute("data-rimg", "loaded");
    } else {
      el.setAttribute("data-rimg", "error");
      trigger(el, "rimg:error");
    }

    trigger(el, "rimg:load");
  });
}

/**
 * Load in a responsive image.
 *
 * Sets the image's `srcset` attribute to the final image URLs, calculated based
 * on the actual size the image is being shown at.
 *
 * @fires rimg:loading
 *        The image URLs have been set and we are waiting for them to load.
 *
 * @fires rimg:loaded
 *        The final image has loaded.
 *
 * @fires rimg:error
 *        The final image failed loading.
 *
 * @param {Item} item
 */
function loadImage(item) {
  var el = item.el;

  // Already loaded?
  var status = el.getAttribute("data-rimg");
  if (status === "loading" || status === "loaded") return;

  // Is the SVG loaded?
  // In Firefox, el.complete always returns true so we also check el.naturalWidth,
  // which equals 0 until the image loads
  if (el.naturalWidth == 0 && el.complete && !item.isBackgroundImage) {
    // Wait for the load event, then call load image
    el.addEventListener("load", function cb() {
      el.removeEventListener("load", cb);
      loadImage(item);
    });

    return;
  }

  // Trigger loading event, and stop if cancelled
  if (trigger(el, "rimg:loading")) return;

  // Mark as loading
  el.setAttribute("data-rimg", "loading");

  // Get element size. This is used as the ideal display size.
  var size = getElementSize(item.el);

  size.width *= item.scale;
  size.height *= item.scale;

  if (item.placeholder) {
    // Load a placeholder image first, followed by the full image. Force the
    // element to keep its dimensions while it loads. If the image is smaller
    // than the element size, use the image's size. Density is taken into account
    // for HiDPI devices to avoid blurry images.
    if (!item.isBackgroundImage) {
      el.setAttribute(
        "width",
        Math.min(Math.floor(item.max.width / item.density), size.width)
      );
      el.setAttribute(
        "height",
        Math.min(Math.floor(item.max.height / item.density), size.height)
      );
    }

    setImage(item, item.placeholder, true, function () {
      return loadFullImage(item, size);
    });
  } else {
    loadFullImage(item, size);
  }
}

/**
 * Prepare an element to be displayed on the screen.
 *
 * Images have special logic applied to them to swap out the different sources.
 *
 * @fires rimg:enter
 *        The element is entering the viewport.
 *
 * @param {HTMLElement} el
 * @param {Settings} options
 */
function load(el, options) {
  if (!el) return;
  trigger(el, "rimg:enter");

  var item = parseItem(el, options);

  if (item.isImage) {
    if (!item.isBackgroundImage) {
      el.setAttribute("data-rimg-template-svg", el.getAttribute("srcset"));
    }

    loadImage(item);
  }
}

/**
 * Reset an element's state so that its image can be recalculated.
 *
 * @fires rimg:update
 *        The element is being updated.
 *
 * @param {HTMLElement} el
 * @param {Settings} options
 */
function update(el, options) {
  if (!el) return;
  trigger(el, "rimg:update");

  var item = parseItem(el, options);

  if (item.isImage) {
    if (!item.isBackgroundImage) {
      el.setAttribute("data-rimg", "lazy");
      el.setAttribute("srcset", el.getAttribute("data-rimg-template-svg"));
    }

    loadImage(item);
  }
}

// Dimension metafields starts here
jscGetLocationQty = (locations, name) => Number(locations?.[name] || 0);

jscGetShopifyCollectiveQty = (locations) => {
  let total = 0;
  for (const [name, qty] of Object.entries(locations || {})) {
    if (!name.includes('via-shopify-collective')) continue;
    if (
      name.includes('-on-hand') ||
      name.includes('-in-coming') ||
      name.includes('-committed')
    ) {
      continue;
    }
    total += Number(qty) || 0;
  }
  return total;
};

jscResolveSupplierWarehouseName = (locations) => {
  if (jscGetLocationQty(locations, 'supplier-warehouse-10-days') > 0) {
    return 'supplier-warehouse-10-days';
  }
  if (jscGetLocationQty(locations, 'supplier-warehouse-5-days') > 0) {
    return 'supplier-warehouse-5-days';
  }
  return 'supplier-warehouse-10-days';
};

jscResolveOnlineSydneyName = (locations) => {
  const onlineInv = jscGetLocationQty(locations, 'online-sydney');
  const showroomInv = jscGetLocationQty(locations, 'sydney-showroom');
  const onlineExists = Object.prototype.hasOwnProperty.call(locations, 'online-sydney');
  const showroomExists = Object.prototype.hasOwnProperty.call(locations, 'sydney-showroom');

  if (showroomExists && onlineExists) {
    if (onlineInv === 0 && showroomInv === 0) return 'sydney-showroom';
    if (onlineInv > 0 && showroomInv === 0) return 'online-sydney';
    if (onlineInv > 0 || showroomInv > 0) return 'sydney-showroom';
  } else if (showroomExists && !onlineExists) {
    return 'sydney-showroom';
  } else if (onlineExists && !showroomExists) {
    return 'online-sydney';
  }
  return '';
};

jscResolveLocationQuantities = (locations) => {
  const supplierWareHouseName = jscResolveSupplierWarehouseName(locations || {});
  const onlineSydneyName = jscResolveOnlineSydneyName(locations || {});

  return {
    online_sydney: onlineSydneyName ? jscGetLocationQty(locations, onlineSydneyName) : 0,
    sydney_showrooms: jscGetLocationQty(locations, 'sydney-warehouse'),
    melbourne_showrooms: jscGetLocationQty(locations, 'melbourne-showroom'),
    melbourne_display: jscGetLocationQty(locations, 'melbourne-showroom-display-stock'),
    sydney_display: jscGetLocationQty(locations, 'sydney-showroom-display-stock'),
    supplier_warehouse:
      jscGetLocationQty(locations, supplierWareHouseName) +
      jscGetShopifyCollectiveQty(locations),
  };
};

jscFormatInventoryHeader = (locations) => {
  const loc = jscResolveLocationQuantities(locations || {});
  const totalStock =
    loc.online_sydney + loc.melbourne_showrooms + loc.sydney_showrooms + loc.supplier_warehouse;
  const totalStockDisplay = loc.melbourne_display + loc.sydney_display;
  const formatQty = (qty) => (qty > 12 ? '12+' : String(qty));

  let text = `[ready to ship: ${totalStock > 0 ? formatQty(totalStock) : '0'}`;
  if (totalStockDisplay > 0) {
    text += ` / display stock: ${formatQty(totalStockDisplay)}`;
  }
  text += ']';
  return text;
};

updateAvailabilityHeader = (html, variant, sectionId) => {
  const currentTotalInventory = document.querySelector('.jsc-total-inventory');
  const currentStoreAvailable = document.querySelector('#store_available');
  const currentSection = sectionId ? document.querySelector(`#shopify-section-${sectionId}`) : null;
  const sectionRoot = html && sectionId ? (html.querySelector(`#shopify-section-${sectionId}`) || html) : html;

  if (variant && currentTotalInventory) {
    const dataEl = document.getElementById('jsc-variant-inventory-data');
    if (dataEl) {
      try {
        const data = JSON.parse(dataEl.textContent);
        const entry = data[String(variant.id)];
        if (entry && entry.locations) {
          currentTotalInventory.innerHTML = jscFormatInventoryHeader(entry.locations);
        }
      } catch (error) {
        console.error('Failed to update availability header from variant data:', error);
      }
    }
  }

  if (html && sectionId && currentStoreAvailable) {
    const newStoreAvailable = sectionRoot.querySelector('#store_available');

    if (newStoreAvailable) {
      currentStoreAvailable.className = newStoreAvailable.className;
    } else if (currentTotalInventory) {
      const newTotalInventory = sectionRoot.querySelector('.jsc-total-inventory');
      if (newTotalInventory) {
        currentTotalInventory.innerHTML = newTotalInventory.innerHTML;
      }
    }
  }

  if (sectionRoot) {
    const newBtn = sectionRoot.querySelector('.jsc-add-to-cart-btn');
    const currentBtn = currentSection?.querySelector('.jsc-add-to-cart-btn') || document.querySelector('.jsc-add-to-cart-btn');
    if (newBtn && currentBtn) {
      currentBtn.textContent = newBtn.textContent;
      if (newBtn.disabled) {
        currentBtn.setAttribute('disabled', 'disabled');
      } else {
        currentBtn.removeAttribute('disabled');
      }

      Array.from(newBtn.attributes).forEach((attr) => {
        if (attr.name.startsWith('data-')) {
          currentBtn.setAttribute(attr.name, attr.value);
        }
      });

      currentBtn.className = newBtn.className;

      if (newBtn.getAttribute('data-sold-out') === 'true') {
        currentBtn.removeAttribute('onclick');
      } else {
        currentBtn.setAttribute('onclick', 'pdpBtn(this)');
      }
    }

    const newSubmitBtn = sectionRoot.querySelector('[data-add-to-cart]');
    const currentSubmitBtn = currentSection?.querySelector('[data-add-to-cart]') || document.querySelector('[data-add-to-cart]');
    if (newSubmitBtn && currentSubmitBtn) {
      const newSubmitSpan = newSubmitBtn.querySelector('span');
      const currentSubmitSpan = currentSubmitBtn.querySelector('span');
      if (newSubmitSpan && currentSubmitSpan) {
        currentSubmitSpan.textContent = newSubmitSpan.textContent;
      }

      if (newSubmitBtn.disabled) {
        currentSubmitBtn.setAttribute('disabled', 'disabled');
      } else {
        currentSubmitBtn.removeAttribute('disabled');
      }
    }

    const newPdpTexts = sectionRoot.querySelectorAll('.jsc-pdp-text');
    const currentPdpTexts = document.querySelectorAll('.jsc-pdp-text');
    newPdpTexts.forEach((newEl, index) => {
      if (currentPdpTexts[index]) {
        currentPdpTexts[index].innerHTML = newEl.innerHTML;
      }
    });

    const newCheckmarks = sectionRoot.querySelectorAll('.product-block--sales-point .icon-circle-checkmark');
    const currentCheckmarks = document.querySelectorAll('.product-block--sales-point .icon-circle-checkmark');
    newCheckmarks.forEach((newEl, index) => {
      if (currentCheckmarks[index]) {
        currentCheckmarks[index].className = newEl.className;
      }
    });
  }
};

onVariantChange = () => {
  const registeredEvents = new Set();

  // Listen to modern variant change events from block-variant-picker
  document.querySelectorAll('section.page-content--product[data-section-id][data-product-id]').forEach(function(section) {
    const sectionId = section.getAttribute('data-section-id');
    const productId = section.getAttribute('data-product-id');
    const eventName = `variant:change:${sectionId}:${productId}`;

    if (registeredEvents.has(eventName)) return;
    registeredEvents.add(eventName);

    document.addEventListener(eventName, function(event) {
      const variant = event.detail?.variant;
      const html = event.detail?.html;
      const loading = event.detail?.loading;
      if (!variant || loading) return;

      updateAvailabilityHeader(html, variant, sectionId);

      variantChange = variant.id;
      onloadvariant = 1;
      var $vid = variant.id;

      $('.jsc-dimension-content').hide();
      $('.jsc-dimension-variant-' + $vid).show();

      // change label
      var $val = $('.jsc-label-' + $vid).val();
      var $more = $('.jsc-label-' + $vid).attr('data-more');

      $('.product__badge').remove();
      $('.jsc-badge-pdp').children().remove();
      $('.label-exist').attr('style','padding-top:15px;');

      if ($val) {
        var $html = `<span class="product__badge jsc-productitem__badge" data-badge-sales="" style="">${$val}</span>`
        $('.label-exist').prepend($html);
        $('.label-exist').attr('style','padding-top:15px;padding-bottom:20px;');
        if ($more) {
          var $moreHtml = `<p class="m-b-0 m-t-0 fontWeight-9 ">${$more}</p>`
          $('.jsc-badge-pdp').append($moreHtml);
        }
      }
    });
  });
  
  // Keep legacy support for old variant picker selector
  $('.product-single__variants').on('change', function (e) {
    variantChange = $(this).find(":selected").val();
    onloadvariant = 1;
    var $vid = $(this).find(':selected').val();

    $('.jsc-dimension-content').hide();
    $('.jsc-dimension-variant-' + $vid).show();

    // change label
    var $val = $('.jsc-label-' + $vid).val();
    var $more = $('.jsc-label-' + $vid).attr('data-more');

    $('.product__badge').remove();
    $('.jsc-badge-pdp').children().remove();
    $('.label-exist').attr('style','padding-top:15px;');

    if ($val) {
      var $html = `<span class="product__badge jsc-productitem__badge" data-badge-sales="" style="">${$val}</span>`
      $('.label-exist').prepend($html);
      $('.label-exist').attr('style','padding-top:15px;padding-bottom:20px;');
      if ($more) {
        var $moreHtml = `<p class="m-b-0 m-t-0 fontWeight-9 ">${$more}</p>`
        $('.jsc-badge-pdp').append($moreHtml);
      }
    }
  });
}
// Dimension metafields ends here

// Authority cart attributes scripts starts here
validate_option = (e) =>{
  // var $this = $(e);
  // var $authOption = $('#authority_to_leave');

  // if ($authOption.val() == '') {
  //   $('#jsc-error_auth').show();
  // } else {
  //   $('#jsc-error_auth').hide();
  //   $('#checkout_btn').click();
  // }
  $('#checkout_btn').click();
}
openOption = (e) =>{
  var $this = $(e);

  toggleOption();
}
authorityOption = (e) =>{
  var $this = $(e);
  var $selectedText = $this.text();

  $('#authority_to_leave').val($selectedText);
  $('.jsc-authority-select-text').text($selectedText);
  $this.parent().find('span').removeClass('is-selected');
  $this.addClass('is-selected');
  toggleOption();
  $('#jsc-error_auth').hide();

  if ($('#authority_to_leave').val() == 'AUTHORITY TO LEAVE IN SAFE SPOT (detail below)') {
    $('.jsc-authority-disclamer').show();
  } else {
    $('.jsc-authority-disclamer').hide();
  }
}

toggleOption = () =>{
  $('.jsc-authority-select-option').toggle();
  $('.jsc-angle-down, .jsc-angle-up').toggleClass('jsc-angle-down jsc-angle-up');
}
// Authority cart attributes scripts ends here

// Giftwrap Line Item script start here
toggle_textarea = (evt, key, p, vid) => {

  var $propObj = JSON.parse(p);
  var path = $(evt).parents(".jsc__giftwrap").find(".textarea__giftwrap");
  var path2 = $(evt).parents(".jsc__giftwrap").find(".line_item_properties");
  //console.log($(evt).parents(".jsc__giftwrap").find(".textarea__giftwrap"));

  var $intVid = parseInt(vid);
  var $qtyField = $(evt).parents('.cart__item-sub').find('.js-qty__num');
  var $qty = parseInt($qtyField.val());
  var $minusBtn =  $(evt).parents('.cart__item-sub').find('.js-qty__adjust--minus');



  if ($(evt).prop("checked") == true) {
    path.show();

    var inputData = path2.val();
    $propObj["Giftwrap_text"] = inputData;

    if (inputData != '') {
      jQuery.ajax({
        url: "/cart/change.js",
        dataType: "json",
        data: { id: key, properties: $propObj },
        error: function () {
          console.log(e);
        },
      });
    }
  } else if ($(evt).prop("checked") == false) {
    path.hide();
    delete $propObj["Giftwrap_text"];
    if ($.isEmptyObject($propObj)) {
      CartJS.removeItemById(key,{
        "success": function(data, textStatus, jqXHR) {
          console.log('goodo',data);
          jQuery.ajax({
            url: "/cart/add.js",
            type: "post",
            dataType: "json",
            data: { id: $intVid, quantity: $qty },
            error: function () {
              setTimeout(function(){
                // Check if modal is showing before clicking minus button
                if (!$('#jsc-modal-new').is(':visible')) {
                  $qtyField.val($qty + 1);
                  $minusBtn.click();
                }
              },900);
            },
          });
        },
        "error": function(jqXHR, textStatus, errorThrown) {
          console.log("Error occur !", errorThrown);
        }
      });
    } else {
      jQuery.ajax({
        url: "/cart/change.js",
        type: "post",
        dataType: "json",
        data: { id: key, properties: $propObj },
        success: function(){
          // Check if modal is showing before clicking minus button
          if (!$('#jsc-modal-new').is(':visible')) {
            $qtyField.val($qty + 1);
            $minusBtn.click();
          }
        },
        error: function () {
          console.log(e);
        },
      });
    }
  }

}

update_line_item = (evt, key,vid, p, q) => {

  var $propObj = JSON.parse(p);
  var inputData = $(evt).parents(".jsc__giftwrap").find(".line_item_properties").val();
  delete $propObj['Giftwrap_text'];

  $propObj["Giftwrap_text"] = inputData;

  var $qtyField = $(evt).parents('.cart__item-sub').find('.js-qty__num');
  var $qty = parseInt($qtyField.val());
  var $minusBtn =  $(evt).parents('.cart__item-sub').find('.js-qty__adjust--minus');

    jQuery.ajax({
      url: "/cart/change.js",
      type: "post",
      dataType: "json",
      data: { id: key, properties: $propObj },
      error: function (xhr, status, error) {
        console.log('Ajax error:', error);
      },
      success: function () {},
    })
    .done(function (e) {
      var path2 = "#textarea-" + vid;
      $(evt).parents(path2).find(".save_giftwrap").addClass("actived");
      $qtyField.val($qty + 1);
      $minusBtn.click();
      
      // Show success message
      var successMessage = $('<div class="giftwrap-success-message" style="color: #28a745; font-size: 14px; margin-top: 8px; font-weight: 500;">✓ Gift message updated successfully!</div>');
      $(evt).parents(path2).find(".jsc-giftwrap-container").after(successMessage);
      
      // Hide success message after 3 seconds
      setTimeout(function() {
        successMessage.fadeOut(500, function() {
          successMessage.remove();
        });
      }, 3000);
    });
}

characters_count = (evt ,vid ) => {
  var path = $(evt).parents(".jsc__giftwrap").find(".count_characters");
  var path
  var characters_count = $(evt).val().length;
  path.text(95 - characters_count);
  var path2 = "#textarea-"+vid;
  $(evt).parents(path2).find(".save_giftwrap").removeClass("actived");
}


closeprompt = (evt, vid) => {
  var id = "myModal-" + vid;
  $(evt).parents(".prompt_box").find(".modal_prompt").hide();
}

any_label_exist = () => {
  if ($(".product__badge").length) {
   $(".label-exist").css( "padding-bottom" , "20px");
  }
}

wishList = (e) =>{
  var $this = $(e);
  var $productJson = $this.attr('data-wishjson');
  var $obj = JSON.parse($productJson);
  var $isRemove = $this.hasClass('swym-added');

  if ($isRemove) {
    window._swat.removeFromWishList(
      {
        "epi": $obj.epi,
        "empi": $obj.empi,
        "du": `${$obj.du}`,
        "iu": `${$obj.iu}`,
        "pr": $obj.pr,
        "stk": $obj.stk,
        "variants": `${$obj.variants}`
      },
      function(r) {
        $this.removeClass('swym-added');
      }
    );
  } else {
    window._swat.addToWishList(
      {
        "epi": $obj.epi,
        "empi": $obj.empi,
        "du": `${$obj.du}`,
        "iu": `${$obj.iu}`,
        "pr": $obj.pr,
        "stk": $obj.stk,
        "variants": `${$obj.variants}`
      },
      function(r) {
        $this.addClass('swym-added');
      }
    );
  }
}

onloadWishlist = () =>{
  if (window.location.pathname.includes('/products/')) {
    setTimeout(function(){
      window._swat.fetch( function(r) {
        for (var i = 0; i < r.length; i++) {
          var $pId = r[i].empi;
          $('.jsc-product_'+$pId).addClass('swym-added');
        }
      });
    },6000);
  }
}

removeCartAuthority = () =>{
  setTimeout(function () {
    $.when($.getJSON('/cart.js', function(cart) {
      $cartItems = cart.items;

    })).then(function(cart){
      var isNotGiftCardOnly = false;
      for (var a = 0; a < $cartItems.length; a++) {
        if (!$cartItems[a].gift_card) {
          isNotGiftCardOnly = true;
        }
      }

        if (!isNotGiftCardOnly) {
          CartJS.setNote("");
          // $('.jsc-authority-content').remove();
          $('.jsc-cart-note').hide();
          $('.jsc-cart-shipping-text').hide();
        }else {
          $('.jsc-cart-note').show();
          $('.jsc-cart-shipping-text').show();
        }
    });
  }, 1000);
}

cartRemove = (e) =>{
  var $this = $(e);
  
  // Find the quantity input with data-id attribute
  var $qtyInput = $this.closest('.cart__item').find('.js-qty__num');
  var $cartItem = $this.closest('.cart__item');
  
  // Get identifiers from the cart item
  var dataId = $qtyInput.attr('data-id');
  var productId = $qtyInput.attr('data-product-id');
  var variantId = $qtyInput.attr('data-id'); // This might be the variant ID
  
  console.log('Debug cart removal:', {
    dataId: dataId,
    productId: productId,
    variantId: variantId,
    cartItemElement: $cartItem[0]
  });
  
  // Fetch current cart to find the exact line item to remove
  fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
      // Find the matching line item
      var lineItemToRemove = cart.items.find(item => {
        // Match by line item key (most reliable)
        return item.key === dataId || 
               item.id === dataId ||
               (item.product_id == productId && item.variant_id == variantId);
      });
      
      console.log('Found line item to remove:', lineItemToRemove);
      
      if (!lineItemToRemove) {
        console.error('Could not find matching line item in cart');
        alert('Could not find item in cart. Please refresh the page.');
        return;
      }
      
      // Remove the item using the correct line item key
      fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({
          id: lineItemToRemove.key,
          quantity: 0
        })
      })
        .then(response => response.json())
        .then(cart => {
          console.log('Item removed successfully:', cart);
          
          // Update cart bubble count
          $('.cart-link__bubble-num').text(cart.item_count);
          
          // Hide cart bubble if cart is empty
          if (cart.item_count === 0) {
            $('.cart-link__bubble-num').hide();
          } else {
            $('.cart-link__bubble-num').show();
          }
          
          // Dispatch cart quantity event to update UI
          document.dispatchEvent(new CustomEvent('cart:quantity', {
            detail: [lineItemToRemove.key, 0, $qtyInput[0]]
          }));
          
          // Dispatch cart refresh event to update cart drawer
          document.dispatchEvent(new CustomEvent('cart:refresh'));
          
          // Close cart drawer if cart is empty and not on cart page
          if (cart.item_count === 0 && !window.location.pathname.includes('/cart')) {
            document.dispatchEvent(new CustomEvent('cart:close'));
          }
          
          // Call removeCartAuthority after successful removal
          removeCartAuthority();
        })
        .catch(error => {
          console.error('Error removing cart item:', error);
          alert('Failed to remove item. Please try again.');
        });
    })
    .catch(error => {
      console.error('Error fetching cart:', error);
      alert('Could not load cart. Please try again.');
    });
}

//Megamenu on click START

$(".site-nav--has-dropdown > a").click (function(){
  // Close all open windows
  $(".site-nav__dropdown").stop().slideUp(300); 
  // Toggle this window open/close
  $(this).next(".site-nav__dropdown").stop().slideToggle(300);
});

//Megamenu on click END

//start: collection page button scroll
onloadScrollToSection = () => {

  var scrollToEl = $('.jsc-btn-scroll-style');
  // console.log(scrollToEl);
  if (scrollToEl.length > 0) {
    var gridSectionPosition = scrollToEl.offset();
    var theBtn = $('.jsc-collection-scroll');
    
    var $w = $(window).scroll(function(){
      var threshold = $w.scrollTop() + 700;
      // console.log('manual scroll',$w.scrollTop(),threshold,gridSectionPosition.top);

      if (threshold > gridSectionPosition.top) {
        console.log('hide btn');
        theBtn.css({
          display: 'none'
        })
      }
      else {
        console.log('show btn');
        theBtn.css({
          display: 'block'
        })
      }

    });
  }

}
//start: collection page button scroll
jscScrollToSection = (e) => {
  var scrollToEl = $('.jsc-btn-scroll-style');
  
  $('html, body').animate({
    scrollTop: scrollToEl.offset().top - 180
  }, 50);

}


closeNewPopup = (e) => {
  var $this = $(e);

  $this.parents('#jsc-modal-new').hide();
  $('.jsc-popup-availability').children().remove();
}

continueNewPop = (e) => {
  var $this = $(e);
  var $id = $this.attr('data-id');
  // The back_order_note input only exists when there's a value, so no need to check/clear it
  $(`.jsc-atc-${$id}`).click();
  console.log("clicked",$id, $this);
  closeNewPopup(e);
}

pdpBtn = (e, invtory) => {
  var $this = $(e);
  if ($this.prop('disabled') || $this.attr('data-sold-out') === 'true') return;
  var $qty = parseInt($this.parents('.product-block').find('.js-qty__num').val());
  var btnType = $this.attr('data-btn-type');
  var isContSell = $this.attr('data-cont-sale');
  var isDue = $this.attr('data-due');
  var pid = $('.jsc-add-to-cart-btn').attr('data-prod-selected-product-id');
  var vid = $('.jsc-add-to-cart-btn').attr('data-prod-selected-variant-id');
  var invtory = Number($('.jsc-add-to-cart-btn').attr('data-prod-selected-inventory')) || 0;
  var $warehouse_invtory = Number($('.jsc-add-to-cart-btn').attr('data-warehouse-inventory')) || 0;
  var $total_incoming_invtory = Number($('.jsc-add-to-cart-btn').attr('data-total-incoming-inventory')) || 0;
  var due_month = $('.jsc-add-to-cart-btn').attr('data-month');
  var due_month_range = $('.jsc-add-to-cart-btn').attr('data-range');
  var backOrderNote = "";
  var inSupplierWarehouse = false;
  var enableChristmasLogic = $this.attr('data-enable-christmas-logic');

  var invtoryExceptSupplierWarehouseInv = invtory - $warehouse_invtory;
  if (invtoryExceptSupplierWarehouseInv < 0) invtoryExceptSupplierWarehouseInv = 0;
  // Row 11: stock available only in supplier warehouse (SPW and/or SC)
  var isSupplierWarehouseOnly = $warehouse_invtory >= 1 && invtoryExceptSupplierWarehouseInv <= 0;

  console.log("invtoryExceptSupplierWarehouseInv", invtoryExceptSupplierWarehouseInv);
  console.log("isSupplierWarehouseOnly", isSupplierWarehouseOnly);
  console.log("BTNTYPE", btnType);
  $.getJSON('/cart.js', function(cart) {
    for (let i = 0; i < cart.items.length; i++) {
      var $item = cart.items[i];
      var $this_vid = $item.variant_id;

      if ($this_vid == vid) {
        $qty += $item.quantity;
      }
    }

    // Prioritize row 11: always show lead-time popup when only SPW/SC stock,
    // regardless of inventory policy / product status (continue, deny, labels, etc.)
    var shouldShowLeadTimePopup =
      (isSupplierWarehouseOnly || isContSell == "continue") &&
      $qty > invtoryExceptSupplierWarehouseInv;

    if (!shouldShowLeadTimePopup) {
      $(`.jsc-atc-${pid}`).click();
      return;
    }

    var $total = invtory;
    var $html = `<div class="jsc-popup-ava-child">
      <span style="font-weight:bold; font-size:12px;">Available to ship now</span><br>`;

    var $totalInventoryExceptWarehouse = 0;
    if ($total >= 1) {
      $totalInventoryExceptWarehouse = $total - $warehouse_invtory;
      if ($totalInventoryExceptWarehouse <= 0) {
        $totalInventoryExceptWarehouse = 0;
      }
    } else if ($total <= 0) {
      $totalInventoryExceptWarehouse = 0;
    }
    $html += `<span class="location fontSize-12"> ${$totalInventoryExceptWarehouse}</span>`;
    $html += `</div>`;

    var $html2 = '';
    if ($warehouse_invtory >= 1) {
      inSupplierWarehouse = true;
      $html2 = `<div class="jsc-popup-ava-child">
        <span style="font-weight:bold; font-size:16px;">Available in our supplier warehouse</span><br>
        <span style="font-weight:normal; font-size:12px;">please allow approximately 5 business days before your order ships.</span><br>
        <span class="location fontSize-11">${$warehouse_invtory}</span>
      </div>`;
    }

    var $html3 = '';
    if (due_month != "") {
      $html3 = `<div class="jsc-popup-ava-child">
        <span style="font-weight:bold; font-size:12px;">More stock due: ${due_month}</span><br>`;
      if ($total_incoming_invtory >= 1) {
        $html3 += `<span class="location fontSize-12">${$total_incoming_invtory}</span>`;
      }
      $html3 += `</div>`;
    } else {
      $html3 = `<div class="jsc-popup-ava-child">
        <span style="font-weight:bold; font-size:12px;">More stock due: no known eta</span><br>
      </div>`;
    }

    if (inSupplierWarehouse) {
      backOrderNote = "stock location: supplier warehouse, allow + 5 days shipping time";
    }

    if ($total == 0 && due_month != "" && due_month_range != "") {
      backOrderNote = `OOS more stock due ${due_month_range} ${due_month}`;
    } else if ($total == 0 && due_month == "") {
      backOrderNote = "OOS staff to contact regarding availability";
    }

    var combinedHtml = $html + $html2 + $html3;
    $('.jsc-popup-availability').html(combinedHtml);

    if (($warehouse_invtory >= 1) && enableChristmasLogic == 'true') {
      $('.jsc-christmas-logic-msg').show();
    } else {
      $('.jsc-christmas-logic-msg').hide();
    }

    $('#jsc-modal-new').show();
    $('.jsc-tba_continue').attr('data-id', pid);
    // Remove existing back_order_note elements if any
    $('#back_order_note').remove();
    $('label[for="back_order_note"]').remove();
    // Only append the elements if backOrderNote has a value
    if (backOrderNote && backOrderNote.trim() !== '') {
      var $label = $('<label>').attr('for', 'back_order_note').text('back_order_note');
      var $input = $('<input>').attr({
        'id': 'back_order_note',
        'type': 'text',
        'name': 'properties[back_order_note]'
      }).val(backOrderNote);
      $('#jsc-line-item-property-field').append($label).append($input);
    }
  });
}

checkBISBtn = (contSell, totalInv) => {
  var displayBlock = '.swym-isa-button-bar .swym-btn-container .swym-button{ display: block !important; }';
  var displayNone = '.swym-isa-button-bar .swym-btn-container .swym-button{ display: none !important; }';
  var targetDisplay = (contSell === "continue" && totalInv <= 0) ? displayBlock : displayNone;

  // console.log("Inventory", totalInv);

  $('style').each(function() {
      var $styleElement = $(this);
      var styleContent = $styleElement.html();

      if (styleContent.includes(displayBlock) || styleContent.includes(displayNone)) {
          if (!styleContent.includes(targetDisplay)) {
              var newStyleContent = styleContent.includes(displayBlock)
                  ? styleContent.replace(displayBlock, displayNone)
                  : styleContent.replace(displayNone, displayBlock);
              
              $styleElement.html(newStyleContent);
              // console.log("Style rule updated to:", targetDisplay);
          } else {
              // console.log("Style rule already set:", targetDisplay);
          }
      }
  })
}

window.setAvailabilityMenuOpen = function setAvailabilityMenuOpen(isOpen) {
  var menu = document.getElementById('jsc-inventory-location-container');
  var storeAvailable = document.getElementById('store_available');
  var icon = storeAvailable
    ? storeAvailable.querySelector('.jsc-collapsible-icon')
    : document.querySelector('#store_available .jsc-collapsible-icon');

  if (!menu) {
    return;
  }

  menu.classList.toggle('is-open', isOpen);
  menu.style.display = isOpen ? 'block' : 'none';

  if (storeAvailable) {
    storeAvailable.classList.toggle('is-open', isOpen);
  }

  if (icon) {
    icon.style.transform = isOpen ? 'rotate(180deg)' : 'rotate(0deg)';
  }
};

window.toggleMenu = function toggleMenu() {
  var menu = document.getElementById('jsc-inventory-location-container');
  if (!menu) {
    return;
  }
  window.setAvailabilityMenuOpen(!menu.classList.contains('is-open'));
};

toggleSheet = (elementId) => {
  var menu = $('#' + elementId);
  if (menu.css('display') === 'none') {
    menu.css('display', 'block'); // Show the menu
    $('.jsc-collapsible-icon').css('transform', 'rotate(180deg)'); // Rotate the menu icon
  } else {
    menu.css('display', 'none'); // Hide the menu
    $('.jsc-collapsible-icon').css('transform', 'rotate(0deg)'); // Rotate the menu icon
  }
}

setDataImage = (imageTitle) => {
  var element = $('.' + imageTitle);
  var $isCombinedListingPrd = $('.product-single__title').attr('combined-listing-product');
  if ($isCombinedListingPrd == "true") {
    if (element.length > 0) {
      var clickEvent = new MouseEvent('click', {
        view: window,
        bubbles: true,
        cancelable: true
      });
  
      element[0].dispatchEvent(clickEvent);
    }
  }
}
onloadPrdImageForCombinedListingPrd = () => {
  var $isCombinedListingPrd = $('.product-single__title').attr('combined-listing-product');
  var isActiveValue = "";
  if ($isCombinedListingPrd == "true") {
    $(".variant-input input:checked").each(function() {
      isActiveValue = $(this).val();
    });

    var activeElement = $(".product__thumb.is-active");
    
    if (activeElement.hasClass(isActiveValue)) {
    } else {
      activeElement.removeClass("is-active");
      setDataImage(isActiveValue);
    }
  }
}

show_more = (e) => {
  var $this = $(e);

  $this.parents('.product-grid__content').find('.jsc-open_description').click();
}

// Global listener to update cart bubble count whenever cart is updated
document.addEventListener('ajaxProduct:added', function(event) {
  // Fetch current cart and update bubble count
  fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
      $('.cart-link__bubble-num').text(cart.item_count);
      if (cart.item_count === 0) {
        $('.cart-link__bubble-num').hide();
      } else {
        $('.cart-link__bubble-num').show();
      }
    });
});

document.addEventListener('cart:updated', function(event) {
  if (event.detail && event.detail.cart && event.detail.cart.item_count !== undefined) {
    $('.cart-link__bubble-num').text(event.detail.cart.item_count);
    if (event.detail.cart.item_count === 0) {
      $('.cart-link__bubble-num').hide();
    } else {
      $('.cart-link__bubble-num').show();
    }
  }
});

document.addEventListener('cart:refresh', function(event) {
  // Fetch current cart and update bubble count
  fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
      $('.cart-link__bubble-num').text(cart.item_count);
      if (cart.item_count === 0) {
        $('.cart-link__bubble-num').hide();
      } else {
        $('.cart-link__bubble-num').show();
      }
    });
});
//Equalize Grid Height - Feature Collection Section
equalizeFeatureCollectionGridMetaHeights = () => {
  // Reset heights to auto first to get natural heights
  $('.jsc-featured-collection .grid-item__meta').css('height', 'auto');
  
  // Find the maximum height among all .grid-item__meta elements
  var maxHeight = 0;
  $('.jsc-featured-collection .grid-item__meta').each(function() {
    var currentHeight = $(this).outerHeight();
    if (currentHeight > maxHeight) {
      maxHeight = currentHeight;
    }
  });
  
  // Apply the maximum height to all .grid-item__meta elements
  if (maxHeight > 0) {
    $('.jsc-featured-collection .grid-item__meta').css('height', maxHeight + 'px');
  }
  
  // Optional: Re-run on window resize to handle responsive changes
  $(window).off('resize.equalizeFeatureCollectionMetaHeights').on('resize.equalizeFeatureCollectionMetaHeights', function() {
    setTimeout(function() {
      equalizeFeatureCollectionGridMetaHeights();
    }, 100);
  });
}
equalizeProductGridTitleHeightsInContainer = ($container) => {
  var $titles = $container.find('.grid-product__title.fontWeight-9');
  if (!$titles.length) return;

  // Reset so we measure natural heights
  $titles.each(function () {
    this.style.height = 'auto';
    this.style.minHeight = '';
  });

  // Group by parent card top (not title top). Different image heights would
  // otherwise put each title in its own "row" and skip equalization.
  var rows = {};
  $titles.each(function () {
    var card = this.closest('.grid-item, .product-grid-item');
    var top = card ? card.getBoundingClientRect().top : this.getBoundingClientRect().top;
    var key = Math.round(top / 40) * 40;
    if (!rows[key]) rows[key] = [];
    rows[key].push(this);
  });

  Object.keys(rows).forEach(function (key) {
    var maxHeight = 0;
    rows[key].forEach(function (el) {
      maxHeight = Math.max(maxHeight, el.offsetHeight);
    });
    if (maxHeight > 0) {
      rows[key].forEach(function (el) {
        el.style.height = maxHeight + 'px';
      });
    }
  });
};

equalizeFeatureCollectionGridProductTitleHeights = () => {
  // Featured collection: equalize all titles in the section (usually 1 row / carousel)
  $('.jsc-featured-collection').each(function () {
    var $titles = $(this).find('.grid-product__title.fontWeight-9');
    if (!$titles.length) return;

    $titles.each(function () {
      this.style.height = 'auto';
      this.style.minHeight = '';
    });

    var maxHeight = 0;
    $titles.each(function () {
      maxHeight = Math.max(maxHeight, this.offsetHeight);
    });

    if (maxHeight > 0) {
      $titles.each(function () {
        this.style.height = maxHeight + 'px';
      });
    }
  });

  // Other product grids: equalize per visual row (by card top)
  $('.new-grid.product-grid, .featured-collection__carousel-grid-items').each(function () {
    // Skip grids already handled inside a featured collection (avoids double-pass reset)
    if ($(this).closest('.jsc-featured-collection').length) return;
    // Skip cart recommendations — narrow cards clip when heights are forced
    if ($(this).closest('.cart-recommendations').length) return;
    equalizeProductGridTitleHeightsInContainer($(this));
  });

  $(window).off('resize.equalizeFeatureCollectionTitleHeights').on('resize.equalizeFeatureCollectionTitleHeights', function () {
    clearTimeout(window.__jscTitleEqualizeResizeTimer);
    window.__jscTitleEqualizeResizeTimer = setTimeout(equalizeFeatureCollectionGridProductTitleHeights, 150);
  });
};
equalizeFeatureCollectionGridProductVendorHeights = () => {
  // Reset heights to auto first to get natural heights
  $('.jsc-featured-collection .grid-product__vendor.jsc-grid-vendor').css('height', 'auto');
  
  // Find the maximum height among all .grid-product__vendor.jsc-grid-vendor elements
  var maxHeight = 0;
  $('.jsc-featured-collection .grid-product__vendor.jsc-grid-vendor').each(function() {
    var currentHeight = $(this).outerHeight();
    if (currentHeight > maxHeight) {
      maxHeight = currentHeight;
    }
  });
  
  // Apply the maximum height to all .grid-product__vendor.jsc-grid-vendor elements
  if (maxHeight > 0) {
    $('.jsc-featured-collection .grid-product__vendor.jsc-grid-vendor').css('height', maxHeight + 'px');
  }
  
  // Optional: Re-run on window resize to handle responsive changes
  $(window).off('resize.equalizeFeatureCollectionVendorHeights').on('resize.equalizeFeatureCollectionVendorHeights', function() {
    setTimeout(function() {
      equalizeFeatureCollectionGridProductVendorHeights();
    }, 100);
  });
}
//Equalize Grid Height - Main Cart Section
equalizeCartPageGridMetaHeights = () => {
  // Reset heights to auto first to get natural heights
  $('.cart__page .grid-item__meta').css('height', 'auto');
  
  // Find the maximum height among all .grid-item__meta elements
  var maxHeight = 0;
  $('.cart__page .grid-item__meta').each(function() {
    var currentHeight = $(this).outerHeight();
    if (currentHeight > maxHeight) {
      maxHeight = currentHeight;
    }
  });
  
  // Apply the maximum height to all .grid-item__meta elements
  $('.cart__page .grid-item__meta').css('height', maxHeight + 'px');
  
  // Optional: Re-run on window resize to handle responsive changes
  $(window).off('resize.equalizeCartDrawerMetaHeights').on('resize.equalizeCartDrawerMetaHeights', function() {
    setTimeout(function() {
      equalizeCartDrawerGridMetaHeights();
    }, 100);
  });
}
equalizeCartPageGridProductTitleHeights = () => {
  // Reset heights to auto first to get natural heights
  $('.cart__page .grid-product__title.fontWeight-9').css('height', 'auto');
  
  // Find the maximum height among all .grid-product__title.fontWeight-9 elements
  var maxHeight = 0;
  $('.cart__page .grid-product__title.fontWeight-9').each(function() {
    var currentHeight = $(this).outerHeight();
    if (currentHeight > maxHeight) {
      maxHeight = currentHeight;
    }
  });
  console.log("maxHeight", maxHeight);
  // Apply the maximum height to all .grid-product__title.fontWeight-9 elements
  if (maxHeight > 0) {
    $('.cart__page .grid-product__title.fontWeight-9').css('height', maxHeight + 'px');
  }
  
  // Optional: Re-run on window resize to handle responsive changes
  $(window).off('resize.equalizeCartDrawerTitleHeights').on('resize.equalizeCartDrawerTitleHeights', function() {
    setTimeout(function() {
      equalizeCartDrawerGridProductTitleHeights();
    }, 100);
  });
}
equalizeCartPageGridProductVendorHeights = () => {
  // Reset heights to auto first to get natural heights
  $('.cart__page .grid-product__vendor.jsc-grid-vendor').css('height', 'auto');
  
  // Find the maximum height among all .grid-product__vendor.jsc-grid-vendor elements
  var maxHeight = 0;
  $('.cart__page .grid-product__vendor.jsc-grid-vendor').each(function() {
    var currentHeight = $(this).outerHeight();
    if (currentHeight > maxHeight) {
      maxHeight = currentHeight;
    }
  });
  
  // Apply the maximum height to all .grid-product__vendor.jsc-grid-vendor elements
  if (maxHeight > 0) {
    $('.cart__page .grid-product__vendor.jsc-grid-vendor').css('height', maxHeight + 'px');
  }
  
  // Optional: Re-run on window resize to handle responsive changes
  $(window).off('resize.equalizeCartDrawerVendorHeights').on('resize.equalizeCartDrawerVendorHeights', function() {
    setTimeout(function() {
      equalizeCartDrawerGridProductVendorHeights();
    }, 100);
  });
}
//Equalize Grid Height - Cart Drawer Section
equalizeCartDrawerGridMetaHeights = () => {
  // Reset heights to auto first to get natural heights
  $('.cart__drawer-form .grid-item__meta').css('height', 'auto');
  
  // Skip recommendation cards — fixed heights clip titles in the narrow drawer
  var maxHeight = 0;
  $('.cart__drawer-form .grid-item__meta').each(function() {
    if ($(this).closest('.cart-recommendations').length) return;
    var currentHeight = $(this).outerHeight();
    if (currentHeight > maxHeight) {
      maxHeight = currentHeight;
    }
  });
  
  // Apply the maximum height to all .grid-item__meta elements
  $('.cart__drawer-form .grid-item__meta').each(function() {
    if ($(this).closest('.cart-recommendations').length) return;
    if (maxHeight > 0) {
      $(this).css('height', maxHeight + 'px');
    }
  });
  
  // Optional: Re-run on window resize to handle responsive changes
  $(window).off('resize.equalizeCartDrawerMetaHeights').on('resize.equalizeCartDrawerMetaHeights', function() {
    setTimeout(function() {
      equalizeCartDrawerGridMetaHeights();
    }, 100);
  });
}
equalizeCartDrawerGridProductTitleHeights = () => {
  // Reset heights to auto first to get natural heights
  $('.cart__drawer-form .grid-product__title.fontWeight-9').css('height', 'auto');
  
  // Skip recommendation cards — fixed heights cause overlay/cutoff in narrow cards
  var maxHeight = 0;
  $('.cart__drawer-form .grid-product__title.fontWeight-9').each(function() {
    if ($(this).closest('.cart-recommendations').length) return;
    var currentHeight = $(this).outerHeight();
    if (currentHeight > maxHeight) {
      maxHeight = currentHeight;
    }
  });
  // Apply the maximum height to all .grid-product__title.fontWeight-9 elements
  if (maxHeight > 0) {
    $('.cart__drawer-form .grid-product__title.fontWeight-9').each(function() {
      if ($(this).closest('.cart-recommendations').length) return;
      $(this).css('height', maxHeight + 'px');
    });
  }
  
  // Optional: Re-run on window resize to handle responsive changes
  $(window).off('resize.equalizeCartDrawerTitleHeights').on('resize.equalizeCartDrawerTitleHeights', function() {
    setTimeout(function() {
      equalizeCartDrawerGridProductTitleHeights();
    }, 100);
  });
}
equalizeCartDrawerGridProductVendorHeights = () => {
  // Reset heights to auto first to get natural heights
  $('.cart__drawer-form .grid-product__vendor.jsc-grid-vendor').css('height', 'auto');
  
  var maxHeight = 0;
  $('.cart__drawer-form .grid-product__vendor.jsc-grid-vendor').each(function() {
    if ($(this).closest('.cart-recommendations').length) return;
    var currentHeight = $(this).outerHeight();
    if (currentHeight > maxHeight) {
      maxHeight = currentHeight;
    }
  });
  
  // Apply the maximum height to all .grid-product__vendor.jsc-grid-vendor elements
  if (maxHeight > 0) {
    $('.cart__drawer-form .grid-product__vendor.jsc-grid-vendor').each(function() {
      if ($(this).closest('.cart-recommendations').length) return;
      $(this).css('height', maxHeight + 'px');
    });
  }
  
  // Optional: Re-run on window resize to handle responsive changes
  $(window).off('resize.equalizeCartDrawerVendorHeights').on('resize.equalizeCartDrawerVendorHeights', function() {
    setTimeout(function() {
      equalizeCartDrawerGridProductVendorHeights();
    }, 100);
  });
}
//Equalize Grid Height - Boost Collection Section
const setBoostProductTitleHeights = () => {
  const $list = $('.boost-sd__product-list');
  if (!$list.length) return;

  const $titles = $list.find('.boost-sd__product-title');
  $titles.css('height', 'auto');

  const rows = {};
  $titles.each(function() {
    const top = Math.round($(this).offset().top);
    if (!rows[top]) rows[top] = [];
    rows[top].push(this);
  });

  Object.keys(rows).forEach(function(top) {
    let maxHeight = 0;
    rows[top].forEach(function(el) {
      maxHeight = Math.max(maxHeight, $(el).outerHeight());
    });
    if (maxHeight > 0) {
      rows[top].forEach(function(el) {
        $(el).css('height', maxHeight + 'px');
      });
    }
  });

  $(window).off('resize.setBoostTitleHeights').on('resize.setBoostTitleHeights', () => {
    setTimeout(setBoostProductTitleHeights, 100);
  });
};

window.newsletterPopup = function (e) {
  // Support both event objects and element refs from inline handlers
  if (e) {
    if (typeof e.preventDefault === 'function') e.preventDefault()
    if (typeof e.stopPropagation === 'function') e.stopPropagation()
  }

  var el = document.querySelector('newsletter-popup')
  if (!el) return

  var isOpen = el.classList.contains('modal--is-active')

  // Prefer modal API once hydrated (keeps focus trap / esc / backdrop in sync)
  if (el.modal && typeof el.modal.open === 'function') {
    if (isOpen || el.modal.modalIsOpen) {
      el.modal.close()
    } else {
      // Pass event so modal.open can stopPropagation and avoid instant re-close
      el.modal.open(e && e.target ? e : undefined)
    }
    return
  }

  // Fallback before custom element hydrates — class toggle only
  if (isOpen) {
    el.classList.remove('modal--is-active')
    document.documentElement.classList.remove('modal-open')
  } else {
    el.classList.add('modal--is-active')
    document.documentElement.classList.add('modal-open')
  }
}